<template>
  <div
    v-if="verificationStatus.isVerificationRequired"
    class="cf-flex cf-flex--column cf-flex--align-center cf-flex--gap-12 cf-alt-background"
  >
    <div
      v-if="isLoading"
      class="cf-section-loader-container"
    >
      <div class="cf-loader" />
    </div>

    <template v-else>
      <!-- Resend verification link via SMS -->
      <div
        v-if="verificationStatus.isPhoneRequired"
        class="cf-flex cf-flex--row cf-flex--align-center cf-flex--gap-10"
      >
        <span class="cf-icon cf-icon--red far fa-exclamation-circle" />

        <p class="cf-subtitle cf-subtitle--2 cf-subtitle--heavy">
          {{ customPhoneVerificationMessage }}

          <span
            class="cf-subtitle--brand-primary"
            @click="resendSmsPasscodeClickHandler"
          >
            Resend Verification SMS
          </span>
        </p>
      </div>

      <!-- Resend verification link via Email -->
      <div
        v-if="verificationStatus.isEmailRequired"
        class="cf-flex cf-flex--row cf-flex--align-center cf-flex--gap-10"
      >
        <span class="cf-icon cf-icon--red far fa-exclamation-circle" />

        <p class="cf-subtitle cf-subtitle--2 cf-subtitle--heavy">
          {{ customEmailVerificationMessage }}

          <span
            class="cf-subtitle--brand-primary"
            @click="resendEmailVerificationClickHandler"
          >
            Resend Verification Email
          </span>
        </p>
      </div>
    </template>
  </div>
</template>


<script>
  import { mapGetters } from 'vuex';


  export default {
    name: 'CfVerifyAccountCta',

    props: {
      customPhoneVerificationMessage: {
        type: String,
        default: 'Please verify your phone number to complete your account registration.'
      },

      customEmailVerificationMessage: {
        type: String,
        default: 'Please verify your email address to complete your account registration.'
      }
    },

    data() {
      return {
        isLoading: false
      };
    },

    computed: {
      ...mapGetters('session', ['currentUser']),
      ...mapGetters('merchant', ['merchant']),

      verificationStatus() {
        const { isPhoneRequired, isEmailRequired, isVerificationRequired } = this.currentUser.accountVerificationStatus;

        return {
          isPhoneRequired,
          isEmailRequired,
          isVerificationRequired
        };
      }
    },

    methods: {
      async resendSmsPasscodeClickHandler() {
        this.isLoading = true;

        const payload = { contactInfo: this.currentUser.primarySmsNumber, contactType: 'phoneNumber' };

        const { isSuccess } = await this.$store.dispatch('session/resendTwoFactorAuthPasscode', payload);

        if (isSuccess) {
          const twoFactorAuthModalPayload = { ...payload, authType: 'phone-number-verification-required' };

          this.$openModal('twoFactorAuthModal', twoFactorAuthModalPayload);

          // this.$triggerGoogleTrackingEvent('ResendSMSVerification', 'Account');

          this.$triggerNewRelicEvent('ResendSMSVerification', 'Information', 'Resend SMS Verification');
        }

        this.isLoading = false;
      },

      async resendEmailVerificationClickHandler() {
        this.isLoading = true;

        await this.$store.dispatch('session/resendVerificationEmail');

        // this.$triggerGoogleTrackingEvent('ResendEmailVerification', 'Account');

        this.$triggerNewRelicEvent('ResendEmailVerification', 'Information', 'Resend Email Verification');

        this.isLoading = false;
      }
    }
  };
</script>
